export interface InlineImageProperties {
    url?: string;
    width?: string;
    height?: string;
    _class?: string;
    description?: string;
}

export const EditImageCommand = "images.edit-image";
export const EditBlockImageCommand = "block_images.edit-image";
